import React, { useEffect, useRef, useState } from 'react'

interface Props {
  component: React.FC<any>
  index: number
  item: any
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
// @ts-ignore
// eslint-disable-next-line react/prop-types
const FlatListElementWrapper: React.FC<Props> = React.memo(({ component: Component, item, index }) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting)
      },
      { threshold: 0 }
    )

    if (ref.current !== null) observer.observe(ref.current)

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      if (ref.current !== null) observer.unobserve(ref.current)
    }
  }, [])

  return (
    <div ref={ref}>
      {isVisible ? (
        <Component {...item} index={index} lastHeight={ref.current?.clientHeight} />
      ) : (
        <div style={{ height: ref.current?.clientHeight, width: ref.current?.clientWidth }} />
      )}
    </div>
  )
})

export default FlatListElementWrapper
